import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#FF98D0"
}
function ObjFoo067({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    fillOpacity={0.8}
                    d="M71.15 35.6q0-14.75-10.45-25.15Q50.3 0 35.55 0 20.8 0 10.4 10.45 0 20.85 0 35.6q0 14.75 10.4 25.15 10.4 10.4 25.15 10.4 14.75 0 25.15-10.4 10.45-10.4 10.45-25.15z"
                    id="ObjFoo067__Symbol_159_0_Layer0_0_FILL"
                />
                <path
                    fill="#FFF"
                    fillOpacity={0.502}
                    d="M215.9 206.7q-2.05.5-1.85 2.55 2.9 4.85 4.15 12.4.1.55.2 1.2.2.5.55.7.5.45 1.5.2 1.2-.3 1.75-1.45 0-.1.1-.25 0-.95-.05-1.9-.15-2.7-.8-5.4-1.1-4.45-3.1-6.9-1.15-1.5-2.45-1.15m-1.5-2.4q.6-1.5-.65-2.65-1.9-1.9-4.5-3.5l-.05-.05q-1.6-.55-2.1-.45-.5.1-.85.65-.4.6-.25 1.35.1.4.4 1 .6.35 1.1.85 1.1.9 2.15 1.95.5.55 1.05 1.15.15.2.35.3.95.55 1.95.3 1.05-.25 1.4-.9z"
                    id="ObjFoo067__Layer1_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ObjFoo067__Symbol_159_0_Layer0_0_FILL"
                transform="translate(156.95 188.55)"
                id="ObjFoo067__col1n"
            />
            <use xlinkHref="#ObjFoo067__Layer1_0_FILL" />
        </g></g>
    )
}
export default ObjFoo067
